import { useEffect } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { RecipeCard } from '@/components/recipe/recipe-card'
import { SearchBuilder } from '@/components/recipe/search-builder'
import { useRecipeStore } from '@/stores/recipe-store'
import { useAuthStore } from '@/stores/auth-store'

export default function SearchPage() {
  const { getSearchableRecipes, loading, loadRecipes } = useRecipeStore()
  const { user } = useAuthStore()

  useEffect(() => {
    void loadRecipes()
  }, [loadRecipes, user])

  const searchableRecipes = getSearchableRecipes()

  return (
    <div className="container py-8">
      <div className="mx-auto max-w-6xl space-y-6">
        <SearchBuilder />

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center justify-between gap-3">
              <span>Publieke en Toegankelijke Recepten</span>
              <span className="text-sm font-normal text-gray-600">
                {searchableRecipes.length} {searchableRecipes.length === 1 ? 'recept' : 'recepten'} gevonden
              </span>
            </CardTitle>
          </CardHeader>
          <CardContent>
            {loading ? (
              <div className="flex justify-center py-12">
                <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-orange-500"></div>
              </div>
            ) : searchableRecipes.length === 0 ? (
              <div className="py-12 text-center">
                <div className="mx-auto max-w-md">
                  <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gray-100">
                    <span className="text-2xl">Zoek</span>
                  </div>
                  <h3 className="mb-2 text-lg font-medium text-gray-900">Geen recepten gevonden</h3>
                  <p className="text-gray-600">Probeer andere zoektermen of pas je filters aan.</p>
                </div>
              </div>
            ) : (
              <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                {searchableRecipes.map((recipe) => (
                  <RecipeCard key={recipe.id} recipe={recipe} showAuthor={true} className="h-full" />
                ))}
              </div>
            )}
          </CardContent>
        </Card>

        {searchableRecipes.length === 0 && !loading ? (
          <Card className="border-blue-200 bg-blue-50">
            <CardContent className="pt-6">
              <h4 className="mb-3 font-medium text-blue-900">Zoektips</h4>
              <ul className="space-y-2 text-sm text-blue-800">
                <li>Gebruik gedeeltelijke woorden, zoals &quot;pota&quot; voor aardappel.</li>
                <li>Zoek op specifieke ingrediënten zoals kip, prei of pasta.</li>
                <li>Combineer filters voor moeilijkheid, tags en bereidingstijd.</li>
                <li>Zoeken doorzoekt publieke basisrecepten, je persoonlijke recepten en je huishoudrecepten.</li>
                <li>Publieke recepten zijn handig als gedeelde startbibliotheek voor iedereen op het platform.</li>
              </ul>
            </CardContent>
          </Card>
        ) : null}
      </div>
    </div>
  )
}
